import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, AtualizacaoConsumidor } from './types';

export const INITIAL_STATE: AtualizacaoConsumidor = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): AtualizacaoConsumidor {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZACAO_CONSUMIDOR_REQUEST: {
				break;
			}
			case Types.ATUALIZACAO_CONSUMIDOR_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}
			case Types.ATUALIZACAO_CONSUMIDOR_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.ATUALIZACAO_CONSUMIDOR_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
